"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var AlertScript = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M5.00932 17.4099C4.67687 18.0748 5.16037 18.8571 5.90375 18.8571H7.52482C7.90359 18.8571 8.24986 18.6431 8.41925 18.3044L10.6087 13.9254C10.6781 13.7866 10.7143 13.6335 10.7143 13.4782V7C10.7143 6.44772 10.2666 6 9.71429 6H4C3.44772 6 3 6.44772 3 7V12.7143C3 13.2666 3.44772 13.7143 4 13.7143H6.85714L5.00932 17.4099ZM15.295 17.4099C14.9626 18.0748 15.4461 18.8571 16.1895 18.8571H17.8105C18.1893 18.8571 18.5356 18.6431 18.705 18.3044L20.8944 13.9254C20.9639 13.7866 21 13.6335 21 13.4782V7C21 6.44772 20.5523 6 20 6H14.2857C13.7334 6 13.2857 6.44772 13.2857 7V12.7143C13.2857 13.2666 13.7334 13.7143 14.2857 13.7143H17.1429L15.295 17.4099Z" }))); };
exports.default = AlertScript;
